export default "__VITE_ASSET__a13sfy4q__"